<template>
<!-- 業務報告書エラーメッセージ -->
<div>
  <p class="preika-form-message" v-for="error in rowEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in taskEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in planDayEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in planDayRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in progressEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in progressRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in planStartEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in planStartRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in startDayEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in startDayRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in planEndEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in planEndRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in endDayRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in endDayEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in detailsEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in problemEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in causeEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in measureEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalTimeEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalTimeRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in definedEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in definedRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in expectOverEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in expectOverRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalOverEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalOverRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalNightEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalNightRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalHolidayEmpty" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in totalHolidayRegex" :key="error">{{ '※' + error }}</p>
  <p class="preika-form-message" v-for="error in overReasonEmpty" :key="error">{{ '※' + error }}</p>
</div>
</template>

<script>
/*
  時刻の書式は **欄が受け付ける形と同じものを読む。**欄の rules は
  vee-validate の total_time で、その中身は ConstList.WORK_TIME_REGEX。
  ここへ書き写すと、片方だけ広げられたときに「欄は受け付けたのに赤字だけ
  出る」「必須なのに印が点かない」へ戻る。
*/
import ConstList from '../ConstList'

export default {
  name: 'ReportError',
  data() {
    return {
      taskEmpty: [],
      planDayEmpty: [],
      planDayRegex: [],
      progressEmpty: [],
      progressRegex: [],
      planStartEmpty: [],
      planStartRegex: [],
      startDayEmpty: [],
      startDayRegex: [],
      planEndEmpty: [],
      planEndRegex: [],
      endDayRegex: [],
      endDayEmpty: [],
      detailsEmpty: [],
      problemEmpty: [],
      causeEmpty: [],
      measureEmpty: [],
      totalTimeEmpty: [],
      totalTimeRegex: [],
      definedEmpty: [],
      definedRegex: [],
      expectOverEmpty: [],
      expectOverRegex: [],
      totalOverEmpty: [],
      totalOverRegex: [],
      totalNightEmpty: [],
      totalNightRegex: [],
      totalHolidayEmpty: [],
      totalHolidayRegex: [],
      overReasonEmpty: []
    }
  },
  props: {
    task: Array,
    plan_day: Array,
    progress: Array,
    plan_start: Array,
    start_day: Array,
    plan_end: Array,
    end_day: Array,
    details: String,
    problem: String,
    cause: String,
    measures: String,
    total_time: String,
    defined: String,
    expect_over: String,
    total_over: String,
    total_night: String,
    total_holiday: String,
    over_reason: String
  },
  computed: {
    /**
     * 全ての項目が空になっている行。
     *
     * 「追加」で作った空行を1つ残すと保存できないのに、下の *_empty は
     * **同じ行の他の項目が1つでも埋まっているときしか**出していなかったので、
     * 全部空の行には赤字が1つも出ず、押せない理由が画面から消えていた。
     *
     * blur を待たずに computed で持つ。追加した直後の行はまだどこも触って
     * いないので blur が起きない。**触るまで理由が出ないのでは、追加した人には
     * 分からない。**
     */
    rowEmpty: function () {
      const columns = [
        this.task, this.plan_day, this.plan_start, this.plan_end,
        this.progress, this.start_day, this.end_day
      ]
      const rows = []
      const count = (this.task || []).length
      for (let i = 0; i < count; i++) {
        const filled = columns.some(column => (column || [])[i])
        if (!filled) {
          rows.push(i + 1 + '行目が空です。入力するか、行を削除してください。')
        }
      }
      return rows
    },
    /**
     * 時間外事由が必須かどうか。
     *
     * **この画面で必須かどうかを決めるのは、ここ1か所だけ。**
     * 見出しの印・欄の rules・このメッセージが別々に判断していたため、
     * 印は常時点灯、rules は翌月の予定時間外時間、メッセージの入口は当月の
     * 時間外時間、と食い違って**必須なのに何も出なかった。**
     *
     * 見ているのは翌月の「予定時間外時間」。見出し「時間外事由(発生時必須)」も
     * 欄の並びも翌月の表にあり、当月の実績ではなく予定に対する理由を書く欄だから。
     *
     * '0:00' と '00:00' は同じ意味として扱う。**片方だけ見ると、桁を落として
     * 書いた人にだけ理由を求めてしまう。**
     */
    overReasonRequired: function () {
      const planned = String(this.expect_over || '').trim()
      // 未入力・書きかけのときは判断しない。予定時間外時間そのものが必須なので、
      // 先にそちらの赤字が出る。
      if (!planned.match(ConstList.WORK_TIME_REGEX)) {
        return false
      }
      const parts = planned.split(':')
      return Number(parts[0]) > 0 || Number(parts[1]) > 0
    }
  },
  methods: {
    /**
     * 行ごとの空文字チェック。
     *
     * **「同じ行の他の項目が埋まっていれば」という条件を持たない。**
     * その条件があると、全部空の行には何も出ないまま保存ボタンだけが死ぬ。
     * 空かどうかの読み方も保存ボタンの条件（!task[i]）に合わせる。**片方が
     * 空文字だけを見ていると、null の行で「止まっているのに何も出ない」に戻る。**
     *
     * 毎回すべて作り直す。元は1件入れるたびに Set で写しを作って
     * `error = set` と**別の配列へ差し替えていた**ので、空の行が2つ以上
     * あっても画面には1つ目しか出なかった。
     */
    row_field_empty: function (errors, values, message) {
      errors.splice(0, errors.length)
      ;(values || []).forEach((value, i) => {
        if (!value) {
          errors.push(i + 1 + message)
        }
      })
    },
    // 項目の空文字チェック
    task_empty: function () {
      this.row_field_empty(this.taskEmpty, this.task, 'つ目の項目を入力してください ')
    },
    // 予定日数の空文字チェック
    plan_day_empty: function () {
      this.row_field_empty(this.planDayEmpty, this.plan_day, 'つ目の予定日数を入力してください ')
    },
    // 予定日数の入力形式チェック
    plan_day_regex: function () {
      let error = this.planDayRegex
      this.plan_day.forEach((value, i) => {
        if ((value !== "") && (!value.match(/^[0-9]*$/))) {
          error.splice(i, 1, i + 1 + 'つ目の予定日数は数字で入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 進捗率の空文字チェック
    progress_empty: function () {
      this.row_field_empty(this.progressEmpty, this.progress, 'つ目の進捗率を入力してください ')
    },
    /**
     * 進捗率の入力形式チェック。
     *
     * **1つの欄に見張りが2つあり、あとの else が、前の if の置いた赤字を
     * そのまま消していた。**数字以外を入れると、vee-validate の numeric が
     * 保存ボタンを止めるのに、赤字は1つも残らない。押せない理由が画面から
     * 消える、いちばん困る形がここに残っていた。
     *
     * どちらの言い分かを先に決めて、**置くか消すかは最後に1回だけ。**
     * 見張りをもう1つ足す人も、if を足すのではなく message を決める側へ
     * 足すこと。
     */
    progress_regex: function () {
      const error = this.progressRegex
      ;(this.progress || []).forEach((value, i) => {
        // 呼出直後の行は null が入ることがある。value.match で落ちると
        // **他の欄の赤字まで道連れで出なくなる。**
        const text = value == null ? "" : String(value)
        let message = ""
        if ((text !== "") && (!text.match(/^[0-9]*$/))) {
          message = i + 1 + 'つ目の進捗率は半角整数で入力してください '
        } else if ((text !== "") && (Number(text) > 100)) {
          message = i + 1 + 'つ目の進捗率は100以内で入力してください '
        }
        if (message !== "") {
          error.splice(i, 1, message)
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 開始予定の空文字チェック
    plan_start_empty: function () {
      this.row_field_empty(this.planStartEmpty, this.plan_start, 'つ目の開始予定を入力してください ')
    },

    /*
     * **日付4欄の形式検査。**Info.vue が blur のたびに呼ぶのに、
     * この4つが存在せず TypeError になっていた（_empty だけ在った）。
     *
     * 判定は plan_day_regex と同じ形。**厳しくしすぎない**——
     * yyyy-MM-dd を強いると、いま保存できている入力が突然弾かれる。
     * 日付として読めない文字が入っているかだけを見る。
     */
    date_regex: function (errors, values, message) {
      let error = errors
      values.forEach((value, i) => {
        if ((value !== '') && Number.isNaN(Date.parse(value))) {
          error.splice(i, 1, i + 1 + message)
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },

    // 開始予定の入力形式チェック
    plan_start_regex: function () {
      this.date_regex(this.planStartEmpty, this.plan_start,
        'つ目の開始予定は日付として読めません ')
    },

    // 開始日の入力形式チェック
    start_day_regex: function () {
      this.date_regex(this.startDayEmpty, this.start_day,
        'つ目の開始日は日付として読めません ')
    },

    // 完了予定の入力形式チェック
    plan_end_regex: function () {
      this.date_regex(this.planEndEmpty, this.plan_end,
        'つ目の完了予定は日付として読めません ')
    },

    // 完了日の入力形式チェック
    end_day_regex: function () {
      this.date_regex(this.endDayEmpty, this.end_day,
        'つ目の完了日は日付として読めません ')
    },
    // 開始日の空文字チェック
    start_day_empty: function () {
      this.row_field_empty(this.startDayEmpty, this.start_day, 'つ目の開始日を入力してください ')
    },
    // 完了予定の空文字チェック
    plan_end_empty: function () {
      this.row_field_empty(this.planEndEmpty, this.plan_end, 'つ目の完了予定を入力してください ')
    },
    // 完了日の空文字チェック
    end_day_empty: function () {
      let error = this.endDayEmpty
      this.end_day.forEach((value, i, array) => {
        if (((this.task[i] !== "") || (this.plan_day[i] !== "") || (this.progress[i] !== "") || (this.start_day[i] !== "") || (this.plan_start[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の完了予定を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 配列以外の空文字チェック
    string_empty: function (errors, name, message) {
      let error = errors
      if (name === "") {
        error.splice(0, 1, message)
        let set = Array.from(new Set(error))
        error = set
      } else {
        error.splice(0, 1)
      }
    },
    // 時間の入力形式チェック
    time_regex: function (errors, name, message) {
      let error = errors
      if ((name !== "") && (!name.match(ConstList.WORK_TIME_REGEX))) {
        error.splice(0, 1, message)
        let set = Array.from(new Set(error))
        error = set
      } else {
        error.splice(0, 1)
      }
    },
    // 作業内容の空文字チェック
    details_empty: function () {
      this.string_empty(
        this.detailsEmpty,
        this.details,
        '作業内容を入力してください'
      )
    },
    // 問題点の空文字チェック
    problem_empty: function () {
      this.string_empty(
        this.problemEmpty,
        this.problem,
        '問題点を入力してください'
      )
    },
    // 原因の空文字チェック
    cause_empty: function () {
      this.string_empty(
        this.causeEmpty,
        this.cause,
        '原因を入力してください'
      )
    },
    // 対策の空文字チェック
    measure_empty: function () {
      this.string_empty(
        this.measureEmpty,
        this.measures,
        '対策を入力してください'
      )
    },
    // 勤務時間の空文字チェック
    total_time_empty: function () {
      this.string_empty(
        this.totalTimeEmpty,
        this.total_time,
        '勤務時間を入力してください'
      )
    },
    // 勤務時間の入力形式チェック
    total_time_regex: function () {
      this.time_regex(
        this.totalTimeRegex,
        this.total_time,
        '勤務時間は入力例のように、半角数字と記号で入力してください'
      )
    },
    // 規定勤務時間の空文字チェック
    defined_empty: function () {
      this.string_empty(
        this.definedEmpty,
        this.defined,
        '規定勤務時間を入力してください'
      )
    },
    // 規定勤務時間の入力形式チェック
    defined_regex: function () {
      this.time_regex(
        this.definedRegex,
        this.defined,
        '規定勤務時間は入力例のように、半角数字と記号で入力してください'
      )
    },
    // 予定時間外勤務時間の空文字チェック
    expect_over_empty: function () {
      this.string_empty(
        this.expectOverEmpty,
        this.expect_over,
        '予定時間外勤務時間を入力してください'
      )
    },
    // 予定時間外勤務時間の入力形式チェック
    expect_over_regex: function () {
      this.time_regex(
        this.expectOverRegex,
        this.expect_over,
        '予定時間外勤務時間は入力例のように、半角数字と記号で入力してください'
      )
    },
    // 時間外勤務時間の空文字チェック
    total_over_empty: function () {
      this.string_empty(
        this.totalOverEmpty,
        this.total_over,
        '時間外勤務時間を入力してください'
      )
    },
    // 時間外勤務時間の入力形式チェック
    total_over_regex: function () {
      this.time_regex(
        this.totalOverRegex,
        this.total_over,
        '時間外勤務時間は入力例のように、半角数字と記号で入力してください'
      )
    },
    // 夜勤勤務時間の空文字チェック
    total_night_empty: function () {
      this.string_empty(
        this.totalNightEmpty,
        this.total_night,
        '夜勤勤務時間を入力してください'
      )
    },
    // 夜勤勤務時間の入力形式チェック
    total_night_regex: function () {
      this.time_regex(
        this.totalNightRegex,
        this.total_night,
        '夜勤勤務時間は入力例のように、半角数字と記号で入力してください'
      )
    },
    // 休日勤務時間の空文字チェック
    total_holiday_empty: function () {
      this.string_empty(
        this.totalHolidayEmpty,
        this.total_holiday,
        '休日勤務時間を入力してください'
      )
    },
    // 休日勤務時間の入力形式チェック
    total_holiday_regex: function () {
      this.time_regex(
        this.totalHolidayRegex,
        this.total_holiday,
        '休日勤務時間は入力例のように、半角数字と記号で入力してください'
      )
    },
    // 時間外事由の空文字チェック
    over_reason_empty: function () {
      // 必須でなくなったときは**消す。**そのまま抜けると、予定時間外時間を
      // 0 に戻したあとも赤字が残り、直したのに直っていないように見える。
      if (!this.overReasonRequired) {
        this.overReasonEmpty.splice(0, 1)
        return
      }
      this.string_empty(
        this.overReasonEmpty,
        this.over_reason,
        // 見出しと同じ言葉にする。画面に無い言葉で言われても、どこを直せば
        // よいか分からない。
        '時間外事由を入力してください'
      )
    }
  }
}
</script>

<style scoped>

</style>
